module.exports = __webpack_public_path__ + "static/media/teksystems.f3268d16.png";